import { render } from "./details.vue?vue&type=template&id=c935c7c6&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"

import "./details.vue?vue&type=style&index=0&id=c935c7c6&lang=less&scoped=true"

import exportComponent from "/Users/zhouti/Desktop/work/fy-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c935c7c6"]])

export default __exports__